import React from 'react';
import { Calendar } from 'primereact/calendar';
import './FloatingLabel.css';

const FloatDateInput = ({ label, value, onChange, ...props }) => {
  return (
    <div className="float-label-calendar">
      <Calendar
        value={value}
        onChange={onChange}
        {...props}
        showIcon
        className="p-inputtext"
        icon="../../images/calender-icon.svg"
        maxDate={new Date()}
      />
      <label className={value ? 'active' : ''}>{label}</label>
    </div>
  );
};

export default FloatDateInput;